import { render, staticRenderFns } from "./EditChild.vue?vue&type=template&id=2ff1426c&"
import script from "./EditChild.vue?vue&type=script&lang=js&"
export * from "./EditChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports